
import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/currencies'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'currencies'

export const metadata = {
  icon: 'eur',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const CurrenciesListPage = createListPage({ metadata, api, actionCreators, Content })
const CurrenciesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { CurrenciesListPage, CurrenciesDetailPage }
